import React, { useState } from 'react'
import { Container, Typography, Grid2, Link, Skeleton, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers'
import { IconChevronRight } from '@tabler/icons-react'
import { Link as RouterLink } from 'react-router-dom'
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

import SearchTextField from '@components/inputs/searchTextField'
import CustomAutocomplete from '@components/inputs/customAutocomplete'

import { UserApiEndpoints } from '@configuration/apiEndpoints'

import { applyFilters, createSearchFilter, createCustomFilter, createYearMonthFilter } from "@utils/filter";

import { AssetUrl } from '@configuration/apiEndpoints'

import "./activity.css";

export default function Activity() {
  const { t } = useTranslation()

  const [query, setQuery] = useState({
    search: "",
    yearMonth: null,
    category: null,
  })

  const { isFetching, error, data, isError } = useQuery({
    queryKey: ['getActivity'],
    queryFn: () =>
      axios.get(UserApiEndpoints.getActivity, { requiresAuth: false }),
    initialData: [],
    select: (res) => res?.data || [],
  })

  // console.log(data)

  const categoryOptions = [
    {
      value: 'Meditation',
      label: t('activity-page.Meditation'),
    },
    {
      value: 'FaHui',
      label: t('activity-page.FaHui'),
    },
    {
      value: 'Seminar',
      label: t('activity-page.Seminar'),
    },
    {
      value: "Fundraising",
      label: t('activity-page.Fundraising'),
    }
  ]

  const filters = [
    createSearchFilter(query.search, ["titleEng", "titleCnsimp", "titleCntrad"]),
    createCustomFilter(query.category?.value, 'category.valueEng', true),
    createYearMonthFilter(dayjs(query.yearMonth).year(), dayjs(query.yearMonth).month(), ['applyStartDate', 'applyCloseDate', 'postDate'])
  ];

  const filteredData = applyFilters(data, filters);

  return (
    <div>
      <Container className='activity-hero'>
        <div className='background'>
          <Typography className='title'>{t('activity')}</Typography>
        </div>
      </Container>
      <Container className='activity-query-section'>
        <Typography className='title'>{t('activity-page.activities')}</Typography>
        <Grid2 container spacing={'25px'}>
          <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <SearchTextField 
              variant='standard'
              label=''
              placeholder={t('activity-page.search')}
              size='medium'
              value={query.search}
              setValue={(value)=>setQuery(prev => {return {...prev, search: value}})}
            />
          </Grid2>
          <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}  display={'flex'} justifyContent={"flex-end"} gap={"25px"}>
            <DatePicker
              value={query.yearMonth ? dayjs(query.yearMonth) : null}
              onChange={(event) => setQuery(prev => {return {...prev, yearMonth: event ? dayjs(event).format("YYYY-MM-DD") : null}})}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'medium',
                  variant: 'standard',
                  placeholder: t('activity-page.yearMonth'),
                },
              }}
              format='YYYY MMM'
              views={['year', 'month']}
            />
            <CustomAutocomplete 
              value={query.category}
              onChange={(value) => setQuery(prev => {return {...prev, category: value}})}
              options={categoryOptions}
              variant='standard'
              placeholder={t('activity-page.category')}
              size='medium'
              sx={{width: "100%"}}
            />
          </Grid2>
        </Grid2>
      </Container>
      <Container className='activity-content-section'>
        <Grid2 container rowSpacing={'50px'} columnSpacing={'30px'}>
          {filteredData.map((data, index)=>(
            <Grid2 size={{ lg: 3, md: 4,  sm: 6, xs: 12 }} key={index}>
              <Box component={RouterLink} to={`/activity/${data?.postGuid}`} onClick={(e) => (!data?.postGuid) && e.preventDefault()} className='card'>
                <div className='image-wrapper'>
                  {isFetching ? 
                    <Skeleton variant="rectangular" sx={{aspectRatio: "32/43", width: "100%", height: "100%"}}/>
                    :
                    <img src={`${AssetUrl}${data?.thumbnailPath}`} style={{aspectRatio: "32/43", width: "100%", backgroundColor: '#E8EBEB', objectFit: 'contain'}}/>
                  }
                </div>
                <Typography className='category'>{isFetching ? <Skeleton variant="text" /> : t(`activity-page.${data?.category?.valueEng}`)}</Typography>
                <Typography className='title'>{isFetching ? <Skeleton variant="text" /> : data?.[`title${t('param')}`] || '-'}</Typography>
                {isFetching ? 
                  <Typography fontSize={'14px'}><Skeleton variant="text"/></Typography> 
                  :
                  <Typography color='#7CA7AD' fontSize={'14px'} style={{display: 'flex', alignItems: 'center'}}>
                    {t('activity-page.viewMore')} <IconChevronRight size={15}/>
                  </Typography>
                }
              </Box>
            </Grid2>
          ))}
        </Grid2>
      </Container>
    </div>
  )
}
